export const clubGenderType = {
    MENS: 'mens',
    WOMEN: 'womens',
};

export const clubSubTypeIds = {
    MENS: 1,
    WOMEN: 2,
    MIXED: 3,
};

export const getDualMatchSupportedSubTypes = (clubSubType) => {
    switch (clubSubType?.id) {
        case clubSubTypeIds.MENS:
            return [clubSubTypeIds.MENS, clubSubTypeIds.MIXED];
        case clubSubTypeIds.WOMEN:
            return [clubSubTypeIds.WOMEN, clubSubTypeIds.MIXED];
        case clubSubTypeIds.MIXED:
        default:
            return [];
    }
};
